import React from 'react'
import styles from './styles.module.css'
import Text from '../../../Text'
import { price } from '../../../../utils/formats'
import { getShopItemPrice } from '../../../../utils/shopItemsAndCart'
import { findItemByType } from '../../../../utils/shopItems'

// "What the bundle saves you" table.
//
// Every number is read from the LIVE offers for the resolved region — each
// component's own shop price, summed — never from a hardcoded list. That matters:
// the bundle's backend `regularPrice` (EUR 3012) is the sum of the components'
// OLD list prices (cockpit 769, seat 449), but those items sell for 699 / 399
// today, so a hardcoded table would quote prices a visitor can disprove by
// opening the cockpit page. Summing the current prices keeps this table and the
// rest of the shop in agreement, and it re-prices itself whenever a component's
// DB price changes (shop prices live in the DB, not in a deploy).
//
// Renders nothing unless every component resolves WITH a price in this region —
// a partial table would understate "bought separately" and overstate the saving.
function SavingsTable({ bundleItem, shopItems }) {
  const types = (bundleItem && bundleItem.bundledItemTypes) || []
  if (!types.length) return null

  const components = types.map((t) => findItemByType(t, shopItems))
  if (components.some((c) => !c || !getShopItemPrice(c))) return null

  const bundlePrice = getShopItemPrice(bundleItem)
  if (!bundlePrice) return null

  const currency = bundlePrice.currency
  if (components.some((c) => getShopItemPrice(c).currency !== currency)) return null

  const separatelyCents = components.reduce((sum, c) => sum + getShopItemPrice(c).priceCents, 0)
  const savingCents = separatelyCents - bundlePrice.priceCents
  // Nothing to brag about if the bundle isn't actually cheaper — say nothing
  // rather than print "You save €0".
  if (savingCents <= 0) return null

  return (
    <div className={styles.savings}>
      <div className={styles.savingsHeader}>
        <Text type="heading-8">Everything in this bundle</Text>
      </div>
      <table className={styles.savingsTable}>
        <thead>
          <tr>
            <th scope="col">Item</th>
            <th scope="col">Bought separately</th>
          </tr>
        </thead>
        <tbody>
          {components.map((c, i) => (
            <tr key={`${c.type}-${i}`}>
              <td>{c.name}</td>
              <td>{price(getShopItemPrice(c).priceCents, currency)}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <th scope="row">Bought separately</th>
            <td>{price(separatelyCents, currency)}</td>
          </tr>
          <tr>
            <th scope="row">Bundle price</th>
            <td>{price(bundlePrice.priceCents, currency)}</td>
          </tr>
          <tr className={styles.savingsTotalRow}>
            <th scope="row">You save</th>
            <td>{price(savingCents, currency)}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  )
}

export default SavingsTable
